
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import { CustomTypographyInputValue } from "@/types/typography";
import {
  addTypographyPresetToStore,
  getUniqueTypographyPresetId
} from "@/lib/typography/typography";
import { ControlsTreeContext } from "@/types/controls";
import { isUiPanelOpen } from "@/lib/panels/panels";
import { saveGlobalSettingsToWordPress } from "@/lib/global-settings/global-settings";
import Dialog from "@/components/UI/Dialog.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";

@Component({ components: { Dialog, TextInput } })
export default class GlobalTypographySaveDialog extends Vue {
  @Prop()
  value!: CustomTypographyInputValue;

  label: string | null = "";

  saveAsGlobal() {
    if (!this.label) {
      return;
    }

    const newPresetId = getUniqueTypographyPresetId();

    addTypographyPresetToStore({
      preset: {
        id: newPresetId,
        label: this.label
      },
      custom: this.value
    });

    // Unless global settings panel is already open, persist this on the server
    if (!isUiPanelOpen("globalSettings")) {
      saveGlobalSettingsToWordPress();
    }

    this.$emit("input", newPresetId);
    this.$emit("close");
  }

  @Inject("context") readonly context!: ControlsTreeContext;
}
